import { talkBrand } from "./brand";

/** Chess prototype copy. The original English stays for the other brands and their tests. */
export function ui(english: string, russian: string): string {
  return talkBrand.id === "chess" ? russian : english;
}

export function uiLocale(): string | undefined {
  return talkBrand.id === "chess" ? "ru-RU" : undefined;
}

export function roleLabel(role: string): string {
  if (talkBrand.id !== "chess") return role;
  if (role === "host") return "Ведущий";
  if (role === "cohost") return "Соведущий";
  if (role === "participant") return "Участник";
  if (role === "guest") return "Гость";
  return role;
}

export function roomStateLabel(state: string): string {
  if (talkBrand.id !== "chess") return state;
  const labels: Record<string, string> = {
    scheduled: "Запланирована",
    opening: "Открывается",
    open: "Открыта",
    locked: "Закрыта",
    ending: "Завершается",
    ended: "Завершена",
    failed: "Ошибка",
  };
  return labels[state] ?? state;
}
